export const UPDATE_EARLY_COD_CHARGES_REQUEST = "UPDATE_EARLY_COD_CHARGES_REQUEST";
export const UPDATE_EARLY_COD_CHARGES_SUCCESS = "UPDATE_EARLY_COD_CHARGES_SUCCESS";
export const UPDATE_EARLY_COD_CHARGES_FAILURE = "UPDATE_EARLY_COD_CHARGES_FAILURE";
export const UPDATE_EARLY_COD_CHARGES_RESET = "UPDATE_EARLY_COD_CHARGES_RESET";
export const updateEarlyCodChargesRequest = (payload) => ({
    type: UPDATE_EARLY_COD_CHARGES_REQUEST,
    payload,
});
export const updateEarlyCodChargesSuccess = (payload) => ({
    type: UPDATE_EARLY_COD_CHARGES_SUCCESS,
    payload,
});
export const updateEarlyCodChargesFailure = (payload) => ({
    type: UPDATE_EARLY_COD_CHARGES_FAILURE,
    payload,
});
export const updateEarlyCodChargesReset = () => ({
    type: UPDATE_EARLY_COD_CHARGES_RESET,
});
